import request, { IServerResponse } from '@/utils/request';
import { CancelDetailReq, CancelDetailRes, CancelUpdateReq } from './define';

export const getCancelDetail = (
    params: CancelDetailReq,
): Promise<IServerResponse<CancelDetailRes>> =>
    request.post('/api/thirdpartnar/contract/cancel/detail', params);

export const postCancelUpdate = (params: CancelUpdateReq): Promise<IServerResponse> =>
    request.post('/api/thirdpartnar/contract/cancel/update', params);
